import { render, staticRenderFns } from "./TaxInvoiceDrClinique.vue?vue&type=template&id=0811486f&scoped=true&"
import script from "./TaxInvoiceDrClinique.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceDrClinique.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=0811486f&scoped=true&lang=css&"
import style1 from "./TaxInvoiceDrClinique.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0811486f",
  null
  
)

export default component.exports